import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { UserState } from '../../Slice/Auth/AuthSlice';
import { loginUser } from '../../ApiCalls/Auth/login';
import { showErrorToast } from '../../../components/atoms/Utlis/Toast';
export const LoginReducer = (builder: ActionReducerMapBuilder<UserState>) => {
    builder.addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.isRegister = false;
        state.error = {};
    })
        .addCase(loginUser.fulfilled, (state, action: PayloadAction<{
            success: boolean,
            status: number,
            message: string,
            data: {
                orderId: string,
                role: number | null,
            }
        }>) => {
            state.loading = false;

            
                state.orderId = action.payload.data.orderId;
                state.apiStatus = true;
        })
        .addCase(loginUser.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;

            // console.log(action.payload);
            state.error = action.payload;
        })

};

// export const LoginReducer = (builder: ActionReducerMapBuilder<UserState>) => {
//     builder
//         .addCase(loginUser.pending, (state) => {
//             state.loading = true;
//             state.isError = false;
//             state.error = {};
//         })
//         .addCase(loginUser.fulfilled, (state, action) => {
//             state.loading = false;
//             if (action.payload.type === "success") {
//                 state.apiStatus = true;
//                 state.orderId = action.payload.message; // store in redux
//                 state.apiStatus = true;
//             } else {
//                 state.isError = true;
//                 state.error = { message: action.payload.message ?? "Failed to send OTP" };
//             }
//         })
//         .addCase(loginUser.rejected, (state, action) => {
//             state.loading = false;
//             state.isError = true;
//             state.error = action.payload || { message: "Something went wrong" };
//         });
// };